import { Panel } from '@lib/components'
import { ThemeColors } from '@octopus-do/octopus-storybook'
import { threadsPanelHide } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { clsJoin } from '@/utils'
import {
  EmptyPlaceholder,
  ShowResolvedToggle,
  ThreadLink,
  useShowResolved,
} from './components'
import { useThreadsList } from './hooks'
import css from './styles.module.css'

export const ThreadsSidebar: React.FC = () => {
  const dispatch = useDispatch()
  const handleOnClose = () => dispatch(threadsPanelHide())

  const { setShowResolved, showResolved } = useShowResolved()
  const items = useThreadsList(showResolved)

  return (
    <Panel
      title="Comments"
      containerClassName={clsJoin(css.threads_sidebar, ThemeColors.light)}
      onClose={handleOnClose}
      additionalHeaderActions={
        <ShowResolvedToggle onChange={setShowResolved} value={showResolved} />
      }
    >
      <ul className={css.threads_list}>
        {items.map((t) => (
          <li key={`${t.kind}:${t.id}`} className={css.threads_item}>
            <ThreadLink thread={t} />
          </li>
        ))}
      </ul>
      {!items.length && <EmptyPlaceholder />}
    </Panel>
  )
}
